import { createApp } from 'vue'
import App from './App.vue'
import cookie from "./plugins/cookie"
import axios from "axios"
import router from "./router";
import store from "./store";
import { useUserTokenStore } from './store/usertoken.js'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import * as cookiejs from "tiny-cookie";


axios.defaults.baseURL = "/api/";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  config => {
    const userTokenStore = useUserTokenStore();
    let token = userTokenStore.token;
    if (!token) {
      token = cookiejs.get('token');
      if (token){
        userTokenStore.setToken(token);
      }
    }


    if (token) {
      config.headers["Authorization"] = `Token ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

const app = createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(cookie)
  .use(store)
  .use(router);

app.mount("#app");
